import type * as router from '@attain-apps/fe/web/main/lib/router'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as ngrxRouterStore from '@ngrx/router-store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

const FALLBACK_DURATION_MS = 1_000

/**
 * Ends transitions that leave the app-page shell or fail before the app page
 * can report that it rendered.
 */
export const finishOnRouterEnd = store.effects.create(
  (feature: Feature, routerFeature: router.Router) =>
    rxjs
      .merge(
        routerFeature.actions.navigate.cancellation.observe(),
        routerFeature.actions.navigate.error.observe(),
        routerFeature.getRoutingAction$('cancellation'),
        routerFeature.getRoutingAction$('error'),
        routerFeature.getRoutingAction$('success'),
      )
      .pipe(
        rxjs.withLatestFrom(feature.selectors.transition.asObservable),
        rxjs.switchMap(([action, transition]) => {
          if (!transition) {
            return rxjs.EMPTY
          }

          const finish = () =>
            feature.actions.finishTransition.from('Router.Ended').create({
              id: transition.id,
            })

          return action.type === ngrxRouterStore.ROUTER_NAVIGATED
            ? rxjs.timer(FALLBACK_DURATION_MS).pipe(rxjs.map(finish))
            : rxjs.of(finish())
        }),
      ),
)
